module.exports = __webpack_public_path__ + "static/CatamaranLight300Latin.89eeec98.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/CatamaranLight300Latin.woff2
// module id = 93
// module chunks = 50294634969860 261391122289601 277288064929247